module.exports = __webpack_public_path__ + "fonts/fa-regular-400.a03df7ab.eot";